export type PhoneCountryCode = 'US' | 'BR';

export interface PhoneCountry {
  code: PhoneCountryCode;
  label: string;
  dialCode: string;
  mask: string;
  placeholder: string;
  digitCount: number;
}

export const PHONE_COUNTRIES: Record<PhoneCountryCode, PhoneCountry> = {
  US: {
    code: 'US',
    label: 'United States',
    dialCode: '1',
    mask: '(999) 999-9999',
    placeholder: '(000) 000-0000',
    digitCount: 10,
  },
  BR: {
    code: 'BR',
    label: 'Brazil',
    dialCode: '55',
    mask: '(99) 99999-9999',
    placeholder: '(00) 00000-0000',
    digitCount: 11,
  },
};

export const DEFAULT_PHONE_COUNTRY: PhoneCountryCode = 'US';
